module.exports = function() {
  return new Worker(__webpack_public_path__ + "1238291e19bb1851d82a.worker.js");
};